import { useMediaQuery } from 'usehooks-ts';
import { Badge, breakpoints, Inline, RadioCard, RadioGroup, Stack, Text, textVariants, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { Field as ReduxFormField } from 'redux-form';
import { Tier } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import { screenReaderOnly } from '../../common/utils/styles';
import { mobileBundleOptionOrder } from '../utils/utils';
import EtgFaresCardContent from './EtgFaresCardContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cardStyles = css`
  border: none;
`;
const promotionalBadgeStyles = css`
  left: 50%;
  position: absolute;
  top: -16px;
  transform: translateX(-50%);
  white-space: nowrap;
  width: fit-content;
`;
const errorCardStyles = css`
  border: solid ${vars.colors.signal.critical.foreground} 1px;
`;
const texts = {
  etgFaresTitle: 'Product.ETG.Fares.Title',
  promotionalText: 'Product.ETG.Fares.Promotional.Text',
  selectOneOptionText: 'Product.SelectOne.Label'
};
const EtgFaresRadioGroup = ({
  bounds,
  discountPercentage,
  firstRadioRef,
  handleOnChange,
  hasDiscount,
  hasValidationError,
  input,
  name,
  numberOfTravelersWithoutInfants,
  sellableOptions
}) => {
  const {
    t
  } = useTranslation();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const orderedSellableOptions = isDesktop ? sellableOptions : mobileBundleOptionOrder(sellableOptions);
  return /*#__PURE__*/_jsx(Stack, {
    children: /*#__PURE__*/_jsxs(RadioGroup, {
      className: cardStyles,
      name: name,
      onChange: handleOnChange,
      selectedValue: input === null || input === void 0 ? void 0 : input.value,
      children: [/*#__PURE__*/_jsx(RadioGroup.Legend, {
        className: screenReaderOnly,
        children: `${t(texts.etgFaresTitle, discountPercentage)} ${t(texts.selectOneOptionText)} ${t('Validation.Required')}`
      }), /*#__PURE__*/_jsx(Inline, {
        collapseBelow: breakpoints._768,
        noWrap: true,
        children: orderedSellableOptions.map((option, optionIndex) => /*#__PURE__*/_jsxs(RadioCard, {
          "aria-checked": Boolean(input === null || input === void 0 ? void 0 : input.value),
          "aria-describedby": `promotional-${optionIndex}-text option-${optionIndex}-price-content included-products-content-${optionIndex}`,
          className: hasValidationError ? errorCardStyles : '',
          id: `choice.${name}.${option.id}`,
          label: /*#__PURE__*/_jsx(Text, {
            "data-testid": `radiocard-label-${option.title}`,
            variant: textVariants._18_EMPHASIZED,
            children: option.title
          }),
          ref: optionIndex === 0 ? firstRadioRef : null,
          value: option.id,
          children: [option.type === Tier.Recommended && /*#__PURE__*/_jsx(Badge, {
            className: promotionalBadgeStyles,
            id: `promotional-${optionIndex}-text`,
            variant: "promotional",
            children: t(texts.promotionalText)
          }), /*#__PURE__*/_jsx(EtgFaresCardContent, {
            bounds: bounds,
            hasDiscount: hasDiscount,
            numberOfTravelersWithoutInfants: numberOfTravelersWithoutInfants,
            option: option,
            optionIndex: optionIndex
          })]
        }, option.id))
      })]
    })
  });
};
const hasBeenSelected = value => value !== null && value !== undefined;
const EtgFaresSelection = ({
  name,
  ...props
}) => {
  const format = value => hasBeenSelected(value === null || value === void 0 ? void 0 : value.value) ? value === null || value === void 0 ? void 0 : value.value.id : undefined;
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: EtgFaresRadioGroup,
    format: format,
    name: name,
    props: {
      name,
      ...props
    }
  });
};
export default EtgFaresSelection;
//# sourceMappingURL=EtgFaresSelection.js.map